import React from 'react'
import { Row, Container, Col } from 'reactstrap'
// import ThankyouImage from '../../assets/images/scanMe/banner.png'
import ThankyouImage from '../../assets/images/scanMe/main_travel_image.png'
import { Button } from '@mui/material';
const ReachMe = () => {
    return (
        <>
            <Container fluid={true} className='mt-4'>
            <Row className="justify-content-center">
                <Col sm="8" className='mx-auto'>
                    <div className="scanme-card" >
                        <div>
                            <div className='position-relative'>
                            <a className="main_image ">
                                <img className="img-fluid for-light" src={ThankyouImage} alt="scanMePage" style={{ width: '100%', height: 'auto', marginTop: '40px', borderRadius: '15px' }} />
                                {/* <Button
                                variant="outlined" // This is a good starting point for a button with a border
                                sx={{
                                    position: 'absolute',
                                    bottom: '24%', // Adjust as needed
                                    left: '50%',
                                    transform: 'translateX(-50%)', // Horizontally centers the button
                                    backgroundColor: 'transparent',
                                    borderRadius: '20px',      // User specified, adjust if you want more oval
                                    color: 'white',            // Text color
                                    textTransform: 'none',
                                    borderColor: 'white',      // Sets the border color to black
                                    borderWidth: '1.5px',      // Adjust thickness as needed
                                    padding: '2px 6px',       // Adjust padding for desired size
                                    fontSize: '1rem',          // Adjust font size
                                    fontWeight: 500,
                                    zIndex: 1,
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.1)', // Slight dark overlay on hover
                                        borderColor: 'black', // Keep border color black on hover
                                        color: 'white',       // Keep text color white on hover
                                    },
                                    position:'absolute'
                                    // ml: 3 is removed as it's not suitable for absolute centered positioning
                                }}
                        > Discover</Button> */}
                            </a>
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                <p style={{textAlign: 'center', fontWeight: '500'}}>We're sending you a 'hello' on WhatsApp, so you know where to find us!</p>
                                <p style={{textAlign: 'center', marginTop: '-14px', fontWeight: '500'}}>You can always visit this page, to check your <a
                                    href="/get-service-details"
                                    style={{ color: '#00239c', fontWeight: 'bold' }}
                                >benefits</a> , file a claim, or <a
                                    href="/get-in-touch"
                                    style={{ color: '#00239c', fontWeight: 'bold' }}
                                >
                                    get in touch
                                </a> with us.</p>
                            </div>
                            
                        </div>
                    </div>
                    <div >
                    </div>
                </Col>
            </Row>
        </Container>
        </>
    )
}

export default ReachMe
